import { useContext } from 'react';
import { PdfContext } from 'utils/context';
import CultureListTable from '../Tables/CultureListTable';

const CultureListOrganic = () => {
  const { invertedCultures } = useContext(PdfContext);

  const numberOfRowPerTable = 10;
  let slicedCultureTable = [];

  for (let i = 0; i < invertedCultures.length; i += numberOfRowPerTable) {
    slicedCultureTable.push(invertedCultures.slice(i, i + numberOfRowPerTable));
  }

  return (
    <div>
      {slicedCultureTable.map((data, index) => (
        <CultureListTable
          key={index}
          truncatedCultures={data}
          messageDuplicate={index > 0 ? '(Suite)' : ''}
          isOrganic={true}
        />
      ))}
    </div>
  );
};

export default CultureListOrganic;
